import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'quotationlist' })
export class QuotationListPipe implements PipeTransform {
    transform(value:any[],searchText:string ){

       if(!searchText){
     //    console.log('no search')
         return value  
       }

       return value.filter(it=>{   
         
           const requirementfor = it.requirementfor.toString().toLowerCase().includes(searchText.toLowerCase())
		    
			
          
           return (requirementfor );      
       }) 
    }
}